import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import './_dialog.scss'

// react-modal throws when the selector matches nothing, so only set it where the app root exists
if (document.getElementById('root')) Modal.setAppElement('#root');

const closeIcon = (
  <svg role="presentation" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.34118 0L0 1.34094L6.65739 8.00095L0.00190258 14.6591L1.34308 16L7.99762 9.34189L14.6579 15.9962L15.999 14.6553L9.3388 8.00095L16 1.34475L14.6598 0.00380421L7.99762 6.65906L1.34118 0Z" fill="currentColor"/>
  </svg>
)

// Compact modal used by the report review flow: left aligned title with a close button, free content and right aligned actions
function Dialog({ title, isOpen, onClose = () => {}, children, actions, testId }) {
  // istanbul ignore next
  const ariaHideApp = process.env.NODE_ENV === 'test' ? false : true;
  return (
    <Modal
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      shouldFocusAfterRender
      shouldReturnFocusAfterClose
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={ariaHideApp}
      style={{
        overlay: { background: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10 },
        content: { maxBlockSize: '90vh', inlineSize: 'calc(100% - 32px)', maxInlineSize: '400px', position: 'static', padding: 0, borderRadius: '8px', border: 0 }
      }}
    >
      <div className="dialog" data-testid={testId}>
        <div className="dialog__header">
          <h2 className="dialog__title">{title}</h2>
          <button type="button" className="dialog__close" onClick={onClose} data-testid="dialog-close" aria-label="Close">
            {closeIcon}
          </button>
        </div>
        <div className="dialog__body">{children}</div>
        {!!actions && <div className="dialog__actions">{actions}</div>}
      </div>
    </Modal>
  )
}

Dialog.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  actions: PropTypes.node,
  testId: PropTypes.string
}

export default Dialog
